import { render, staticRenderFns } from "./imgN.vue?vue&type=template&id=77a24b67&scoped=true"
var script = {}
import style0 from "./imgN.vue?vue&type=style&index=0&id=77a24b67&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a24b67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a24b67')) {
      api.createRecord('77a24b67', component.options)
    } else {
      api.reload('77a24b67', component.options)
    }
    module.hot.accept("./imgN.vue?vue&type=template&id=77a24b67&scoped=true", function () {
      api.rerender('77a24b67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgN.vue"
export default component.exports